export type RoleCard = {
  id: string;
  name: string;
  imageDataUrl: string | null;
  voice: string;
};

export type VideoRow = {
  id: string;
  roleCards: RoleCard[];
  storyboardScript: string;
  videoScript: string;
  aspectRatio: '16:9' | '9:16';
  gridImageUrl?: string | null;
  gridTaskId?: string | null;
  videoUrl?: string | null;
  videoProgress?: number;
  videoStatus?: 'idle' | 'generating' | 'success' | 'failed';
  videoSoraId?: string;
};

export type RowLoadingState = {
  roles?: boolean;
  video?: boolean;
  grid?: boolean;
};

export const createEmptyRoleCard = (rowId: string, index = 1): RoleCard => ({
  id: `${rowId}-role-${index}`,
  name: '未命名',
  imageDataUrl: null,
  voice: '',
});

export const createEmptyVideoRow = (id: string): VideoRow => ({
  id,
  roleCards: [createEmptyRoleCard(id)],
  storyboardScript: '',
  videoScript: '',
  aspectRatio: '16:9',
  gridImageUrl: null,
  gridTaskId: null,
  videoUrl: null,
  videoStatus: 'idle',
  videoProgress: 0,
});

export const resetVideoRow = (row: Pick<VideoRow, 'id'>): VideoRow => createEmptyVideoRow(row.id);

export const isRowBusy = (loading?: RowLoadingState): boolean =>
  Boolean(loading?.roles || loading?.video || loading?.grid);

export const getCollapsedRowMinHeight = (canDelete: boolean): { xs: number; md: number } =>
  canDelete ? { xs: 214, md: 214 } : { xs: 150, md: 190 };

export const getExpandControlPlacement = (): { right: number; bottom: number } => ({
  right: 4,
  bottom: 10,
});

export const getRightActionColumnMetrics = (
  canDelete: boolean,
): { topPadding: number; buttonGap: number } =>
  canDelete ? { topPadding: 2.5, buttonGap: 1 } : { topPadding: 4, buttonGap: 1.6 };
